export const DAYS_OF_WEEK = ["일","월","화","수","목","금","토"]; // SUNDAY...
export const date2dayofweeks = (date) => {
    return DAYS_OF_WEEK[(date || new Date()).getDay()];
};